<template>
  <div>
    <MenuCount_Stock/>
    <Count_Stock/>
  </div>
</template>

<script>
import MenuCount_Stock from "@/components/admin/count_stock/menucount_stock/MenuCount_Stock.vue";
import Count_Stock from "@/components/admin/count_stock/Count_Stock.vue";
export default {
  name: "CountStock",
  components: {
    Count_Stock,
    MenuCount_Stock
  }
}
</script>

<style scoped>

</style>
